import {useCallback, useEffect, useState} from "react";
import {InactiveOrderReminderRepositoryInstance} from "../repository/Order/InactiveOrderReminderRepository";
import {hasPermission} from "../features/Permission/AllowedAccess";
import {inactiveOrderReminderViewPermission} from "../views/permissions";

const REFRESH_MS = 60_000;

export function useInactiveOrderReminderPendingCount(): number | null {
    const enabled = hasPermission(inactiveOrderReminderViewPermission);
    const [count, setCount] = useState<number | null>(null);

    const load = useCallback(() => {
        if (!enabled) {
            setCount(null);
            return;
        }
        InactiveOrderReminderRepositoryInstance.pendingCount({})
            .then((res) => {
                if (!res.None && res.Some) {
                    setCount(res.Some.count ?? 0);
                }
            })
            .catch(() => {
                /* ignore — badge is optional */
            });
    }, [enabled]);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        load();
        const timerId = window.setInterval(load, REFRESH_MS);
        return () => window.clearInterval(timerId);
    }, [enabled, load]);

    return enabled ? count : null;
}
